import { useNavigationLookups } from "@/common/hooks/use-navigation";
import {
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
  Breadcrumb as ShadCnBreadcrumb,
} from "@/components/ui/breadcrumb";
import { Fragment } from "react/jsx-runtime";
import { useLocation } from "wouter";

export function DynamicBreadcrumb() {
  const [location] = useLocation();
  const { hiddenSegments } = useNavigationLookups();

  const pathParts = location.split("/").filter((part) => part !== "");
  const visibleParts = pathParts
    .map((part, index) => ({ part, index }))
    .filter(({ part }) => !hiddenSegments.has(part));

  return (
    <ShadCnBreadcrumb>
      <BreadcrumbList>
        {visibleParts.map(({ part, index }, visibleIndex) => (
          <Fragment key={`breadcrumb_${index}_${part}`}>
            <BreadcrumbItem className="hidden md:block" value={part} previousValues={pathParts.slice(0, index)} />
            {visibleIndex < visibleParts.length - 1 && <BreadcrumbSeparator className="hidden md:block" />}
          </Fragment>
        ))}
      </BreadcrumbList>
    </ShadCnBreadcrumb>
  );
}
